enum WebserviceOcrFields {
	ENABLED = "ocr_enabled",
	INSTANCES = "ocr_instances",
	QUEUE = "ocr_queue",
	LATENCY = "ocr_latency",
}

export default WebserviceOcrFields;